<div
  class="box design-section"
  fxLayout="column">
  @if (showLetsBuild && templateControlService?.allDesignControls?.length <= 1) {
    <div
      style="position: relative; width: 100%">
      <div
        class="lets-build lets-build-container"
        [class.lets-build-slack]="showSlackHeader"
        fxLayout="column"
        fxLayoutAlign="center center"
        (dragenter)="dragenter($event)"
        (dragover)="dragover($event)"
        (drop)="drop($event)">
        <div class="lets-build"><img src="/assets/images/lets-build-template.png" /></div>
        <div class="lets-build lets-build-tagline">{{ 'MANAGEMENT.COMMUNICATION-CENTER.LETS-BUILD-TEMPLATE-TAGLINE' | translate }}</div>
        <div class="lets-build lets-build-details">{{ 'MANAGEMENT.COMMUNICATION-CENTER.LETS-BUILD-TEMPLATE-DETAILS' | translate }}</div>
      </div>
    </div>
  }
  <div
    id="text-tool-bar"
  style="display: none"></div>
  <div
    class="design-surface-container"
    [ngClass]="{ 'is-full-height': isFullHeight, 'is-dark': userPref.isDarkTheme()}"
    fxLayout="row"
    fxLayoutAlign="center start"
    (scroll)="designSurfaceScroll()">
    <div style="height: 100%;">
      <div
        id="design-surface"
        class="design-surface ql-editor"
        [class.design-surface-slack]="showSlackHeader"
        (dragenter)="dragenter($event)"
        (dragover)="dragover($event)"
        (drop)="drop($event)">
        <!-- Slack Header - Not saved with Template -->
        @if (showSlackHeader) {
          <div
            class="slack-header mb-4"
            fxLayout="row"
            fxLayoutAlign="start">
            <div>
              <img
                class="slack-avatar"
                src="http://files.topo.ai/images/icons/t1_solid.png" />
            </div>
            <div>
              <div class="slack-username">TopoONE</div>
              <div class="slack-type">
                <span class="slack-dataset-type">{{ headerDatasetType }}</span>
                @if (headerDatasetType && headerDatasetName) {
                  <span>|</span>
                }
                {{ headerDatasetName }}
              </div>
              <div
                class="slack-name"
              [innerHTML]="slackHeaderName"></div>
            </div>
            <div class="slack-image-block">
              <img src="https://files.topo.ai/images/slack/alert-02.png" />
            </div>
          </div>
        }
        <!-- Microsoft Teams Header - Not saved with Template -->
        @if (showMicrosoftTeamsHeader) {
          <div
            class="microsoft-teams-header mb-4"
            fxLayout="row"
            fxLayoutAlign="start">
            <div class="microsoft-teams-type">
              <span class="microsoft-teams-dataset-type">{{ headerDatasetType }}</span>
              @if (headerDatasetType && headerDatasetName) {
                <span>|</span>
              }
              {{ headerDatasetName }}
            </div>
          </div>
        }
        <!-- Edit Settings Control Wrapper...used by all controls -->
        <div
          id="settings-wrapper-control"
          class="editElementControl">
          <div style="position: absolute; top: -34px; right: 0px">
            <div fxLayout="row">
              <div class="button-bar button-bar-edit">
                <div
                  [ngStyle]="{ display: showEditAction ? 'block' : 'none' }"
                  class="action-button edit-button">
                  <span class="icon icon-edit"></span>
                </div>
                <div
                  [ngStyle]="{ display: showCopyAction ? 'block' : 'none' }"
                  class="action-button copy-button">
                  <span class="icon icon-copy_duplicate"></span>
                </div>
                <div
                  [ngStyle]="{ display: showDeleteAction ? 'block' : 'none' }"
                  class="action-button delete-button">
                  <span class="icon icon-delete_trash"></span>
                </div>
              </div>
              <div
                class="button-bar button-bar-save"
                style="display: none">
                <div class="action-button save-button"><span class="icon icon-check_clear"></span></div>
                <div class="action-button cancel-button"><span class="icon icon-close-X"></span></div>
              </div>
            </div>
          </div>
          <div
            id="edit-window"
            class="edit-window"
            fxLayout="row"
            fxLayoutAlign="start"
            [draggable]="_enableDrag">
            <div
              class="drag-handle"
              fxLayout="row"
              fxLayoutAlign="start stretch">
              <div
                fxLayout="row"
                fxLayoutAlign="center center">
                <span class="icon icon-drag_handle"></span>
              </div>
            </div>
            <div class="content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<topo-rich-text-edit
  [isActive]="templateControlService.isRichTextActive"
  title="{{ 'MANAGEMENT.COMMUNICATION-CENTER.MODIFY-RICH-TEXT' | translate }}"
  [value]="templateControlService.richText"
  (richTextUpdated)="templateControlService.updateRichText($event)"
  (cancelRichText)="templateControlService.cancelRichText()"
  [enableMentions]="enableMentions"
[mentionSearch]="mentionSearch"></topo-rich-text-edit>
